import { FaEye, FaGithub } from "react-icons/fa";

const ProjectsLinks = ({ github, live }) => {
  return (
    <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 justify-center items-center mt-8 md:space-x-4">
      
      {/* GitHub link */}
      <a
        href={github}
        className="flex justify-center items-center gap-2 bg-gray-800 text-white px-6 py-2 rounded hover:bg-gray-900 h-12 w-44"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaGithub className="w-5 h-5" />
        <span>GitHub</span>
      </a>

      {/* Live Preview link */}
      <a
        href={live}
        className="flex items-center gap-2 bg-purple-500 text-white px-6 py-2 rounded hover:bg-purple-600 h-12 w-44"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaEye className="w-5 h-5" />
        <span>Live Preview</span>
      </a>
    </div>
  );
};

export default ProjectsLinks;
